enum LaborSettings {
	isEmployeeAutomaticReturnDate = 'Labor status automatic return date',
}

export enum LaborSettingsHint {
	isEmployeeAutomaticReturnDate = 'Labor status will automatically return to previous available status upon return date expiration.',
}

export default LaborSettings;
